import * as React from 'react';
import { Autocomplete, Button, Grid, ListItemText, TextField, Typography } from '@mui/material';
import { Municipio } from '../Municipios/Municipio';
import { TrameroSearchModel } from './TrameroSearchModel';
import Common from '../utilities/common';
import $ from "jquery";
import { ComunidadAutonoma } from '../ComunidadesAutonomas/ComunidadAutonoma';
import { Provincia } from '../Provincias/Provincia';
import { TipoVia } from '../TiposVia/TipoVia';

export interface ITrameroSearchFormProps {
    onSearch: any
}

export interface ITrameroSearchFormState {
    municipios: Municipio[];
    comunidades: ComunidadAutonoma[];
    provincias: Provincia[];
    tiposVia: TipoVia[]
}

export default class TrameroSearchForm extends React.Component<ITrameroSearchFormProps, ITrameroSearchFormState> {
    _trameroSearchModel: TrameroSearchModel = new TrameroSearchModel();

    public constructor(props: ITrameroSearchFormProps) {
        super(props);

        this.state = {
            municipios: [],
            comunidades: [],
            provincias: [],
            tiposVia: []
        }
    }

    componentDidMount(): void {
        this.GetComunidades();
        this.GetProvincias();
        this.GetMunicipios();
        this.GetTiposVia();
    }

    public render(): React.ReactElement<{}> {
        return (
            <React.Fragment>
                <Typography variant='h5'>
                    Buscador
                </Typography>
                <div className='form'>
                    <Grid container spacing={3}>
                        <Grid item xs={3}>
                            <Autocomplete
                                renderInput={(params) => (
                                    <TextField {...params} label="Comunidad autónoma" variant="standard" />
                                )}
                                onChange={(event: any, newValue: ComunidadAutonoma | null) => {
                                    this._trameroSearchModel.ComunidadAutonoma = newValue?.name!;
                                }}
                                options={this.state.comunidades}
                                getOptionLabel={(option: ComunidadAutonoma) => option.name!}
                                renderOption={(props, item) => (
                                    <li {...props} key={item.id}>
                                    <ListItemText>{item.name}</ListItemText>
                                    </li>
                                )}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <Autocomplete
                                renderInput={(params) => (
                                    <TextField {...params} label="Provincia" variant="standard" />
                                )}
                                onChange={(event: any, newValue: Provincia | null) => {
                                    this._trameroSearchModel.Provincia = newValue?.nombre!;
                                }}
                                options={this.state.provincias}
                                getOptionLabel={(option: Provincia) => option.nombre!}
                                renderOption={(props, item) => (
                                    <li {...props} key={item.id}>
                                    <ListItemText>{item.nombre}</ListItemText>
                                    </li>
                                )}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <Autocomplete
                                renderInput={(params) => (
                                    <TextField {...params} label="Municipio" variant="standard" />
                                )}
                                onChange={(event: any, newValue: Municipio | null) => {
                                    this._trameroSearchModel.Municipio = newValue?.nombre!;
                                }}
                                options={this.state.municipios}
                                getOptionLabel={(option: Municipio) => option.nombre!}
                                renderOption={(props, item) => (
                                    <li {...props} key={item.id}>
                                    <ListItemText>{item.nombre}</ListItemText>
                                    </li>
                                )}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <Autocomplete
                                renderInput={(params) => (
                                    <TextField {...params} label="Tipo de vía" variant="standard" />
                                )}
                                onChange={(event: any, newValue: TipoVia | null) => {
                                    this._trameroSearchModel.TipoVia = newValue?.nombre!;
                                }}
                                options={this.state.tiposVia}
                                getOptionLabel={(option: TipoVia) => option.nombre!}
                                renderOption={(props, item) => (
                                    <li {...props} key={item.id}>
                                    <ListItemText>{item.nombre}</ListItemText>
                                    </li>
                                )}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField label="Calle" fullWidth variant="standard" onChange={(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
                                this._trameroSearchModel.NombreVia = event.target.value;
                            }}/>
                        </Grid>
                        <Grid item xs={12} style={{textAlign: 'right'}}>
                            <Button variant="contained" onClick={this.OnSearch.bind(this)}>
                                Buscar
                            </Button>
                        </Grid>
                    </Grid>
                </div>
            </React.Fragment>
        )
    }

    private OnSearch() {
        this.props.onSearch(this._trameroSearchModel);
    }

    private GetMunicipios(): void {
        let url = `${Common.END_POINT}/masters/municipios`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            console.log(response);
            this.setState(
                {
                    municipios: response
                }
            );
        })
    }

    private GetComunidades(): void {
        let url = `${Common.END_POINT}/masters/comunidadesautonomas/-1`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            this.setState(
                {
                    comunidades: response
                }
            );
        })
    }

    private GetProvincias(): void {
        let url = `${Common.END_POINT}/masters/Provincias`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            this.setState(
                {
                    provincias: response
                }
            );
        })
    }

    private GetTiposVia(): void {
        let url = `${Common.END_POINT}/masters/tiposVia`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            this.setState(
                {
                    tiposVia: response
                }
            );
        })
    }
}